import React from 'react';
import { graphql } from 'gatsby';
import HeaderMain from '../components/HeaderMain';
import Footer from '../components/Footer';
import HeroSingle from '../components/pages/HeroSingle';
import WhatParentsSay from '../components/pages/WhatParentsSay';
import YelpReviews from '../components/pages/YelpReviews';
import SEO from '../components/seo';
import '../styles/app.scss';

const Reviews = ({ data }) => {
    const { wordpressPage: post } = data;
    const test_title = post.yoast_title;
    //const new_seo_title = test_title.replace('&#039;', "'");

    return (
        <>
            <HeaderMain />
            <HeroSingle pageTitle={post.title} />
            <WhatParentsSay />
            <Footer />
        </>
    );
};

export const pageQuery = graphql`
    query($id: String!) {
        wordpressPage(id: { eq: $id }) {
            id
            title
            slug
            acf {
                yelp_reviews {
                    yelp_review_code
                }
            }
        }
    }
`;

export default Reviews;
